// ─── Buyer form options ───────────────────────────────────────────────────

export const principalBuyerOptions = [
  { value: 'principal-buyer', label: 'Principal Buyer' },
  { value: 'principal-representative-advisor', label: 'Principal Representative / Advisor' },
];

export const buyerProfileOptions = [
  { value: 'private-individual', label: 'Private Individual' },
  { value: 'family-office', label: 'Family Office' },
  { value: 'corporate-buyer', label: 'Corporate Buyer' },
  { value: 'fund', label: 'Fund' },
  { value: 'spv-joint-venture', label: 'SPV / Joint Venture' },
  { value: 'other', label: 'Other' },
];

export const fundsOptions = [
  { value: 'yes-fully-liquid', label: 'Yes, fully liquid' },
  { value: 'yes-subject-to-financing', label: 'Yes, subject to financing' },
  { value: 'partially', label: 'Partially' },
  { value: 'no-exploring', label: 'No, exploring' },
];

export const sourceOfFundsOptions = [
  { value: 'cash', label: 'Cash' },
  { value: 'financing', label: 'Financing' },
  { value: 'mixed', label: 'Mixed (cash + financing)' },
  { value: 'undisclosed', label: 'Undisclosed' },
];

export const proofOfFundsOptions = [
  { value: 'yes-immediately', label: 'Yes, can provide immediately' },
  { value: 'yes-upon-nda', label: 'Yes, upon mutual NDA' },
  { value: 'no', label: 'No' },
];

export const completionOptions = [
  { value: 'immediately', label: 'Immediately' },
  { value: '1-3Months', label: '1 - 3 months' },
  { value: '3-6Months', label: '3 - 6 months' },
  { value: '6-12Months', label: '6 - 12 months' },
  { value: '12+Months', label: '12+ months' },
];

export const dealStructureOptions = [
  { value: 'outright-purchase', label: 'Outright Purchase' },
  { value: 'jv-partnership', label: 'JV / Partnership' },
  { value: 'other', label: 'Other' },
];

export const countryOptions = [
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Australia', label: 'Australia' },
  { value: 'Austria', label: 'Austria' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Bahrain', label: 'Bahrain' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'China', label: 'China' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Cypress', label: 'Cypress' },
  { value: 'Croatia', label: 'Croatia' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Finland', label: 'Finland' },
  { value: 'France', label: 'France' },
  { value: 'Greece', label: 'Greece' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Hong-Kong', label: 'Hong Kong' },
  { value: 'Iceland', label: 'Iceland' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'Indonesia', label: 'Indonesia' },
  { value: 'India', label: 'India' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Kenya', label: 'Kenya' },
  { value: 'luxembourg', label: 'Luxembourg' },
  { value: 'Mallorca', label: 'Mallorca' },
  { value: 'Montenegro', label: 'Montenegro' },
  { value: 'Monaco', label: 'Monaco' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'New-Zealand', label: 'New Zealand' },
  { value: 'Nigeria', label: 'Nigeria' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Saudi-Arabia', label: 'Saudi Arabia' },
  { value: 'South-Africa', label: 'South Africa' },
  { value: 'Taiwan', label: 'Taiwan' },
  { value: 'Thailand', label: 'Thailand' },
  { value: 'Turkey', label: 'Turkey' },
  { value: 'Uruguay', label: 'Uruguay' },
  { value: 'United-Arab-Emirates', label: 'United Arab Emirates' },
  { value: 'United-Kingdom', label: 'United Kingdom' },
  { value: 'United-States', label: 'United States' },
  { value: 'Other', label: 'Other' },
];

// Used by BuyerApplicationForm to display human-readable labels for stored values
export const buyerFormValueMap = Object.fromEntries(
  [
    ...principalBuyerOptions,
    ...buyerProfileOptions,
    ...fundsOptions,
    ...sourceOfFundsOptions,
    ...proofOfFundsOptions,
    ...completionOptions,
    ...dealStructureOptions,
  ].map(({ value, label }) => [value, label])
);

// ─── Seller form options ───────────────────────────────────────────────────

export const sellerRepresentationOptions = [
  { value: 'principal-seller', label: 'Principal Seller' },
  { value: 'principal-representative-advisor', label: 'Principal Representative / Advisor' },
];

export const sellerProfileOptions = [
  { value: 'private-individual', label: 'Private Individual' },
  { value: 'corporate-seller', label: 'Corporate Seller' },
  { value: 'fund', label: 'Fund' },
  { value: 'estate-trust', label: 'Estate / Trust' },
  { value: 'other', label: 'Other' },
];

export const documentationOptions = [
  { value: 'financial-statements', label: 'Financial Statements' },
  { value: 'valuation-report', label: 'Valuation Report' },
  { value: 'condition-report', label: 'Condition Report' },
  { value: 'other-report', label: 'Other Report' },
  { value: 'title-documentation', label: 'Title Documentation' },
  { value: 'brochure', label: 'Brochure' },
  { value: 'images', label: 'Images' },
  { value: 'none-yet', label: 'None Yet' },
];

export const proofAvailableOptions = [
  { value: 'redacted-mandate', label: 'Redacted Mandate' },
  { value: 'redacted-email', label: 'Redacted Email' },
  { value: 'redacted-screenshot', label: 'Redacted Screenshot' },
  { value: 'redacted-legal-document', label: 'Redacted Legal Document' },
  { value: 'images', label: 'Images' },
  { value: 'brochure', label: 'Brochure' },
];

export const sellerTimelineOptions = [
  { value: 'immediately', label: 'Immediately' },
  { value: '1-3Months', label: '1 – 3 months' },
  { value: '3-6Months', label: '3 – 6 months' },
  { value: '6-12Months', label: '6 – 12 months' },
  { value: '12+Months', label: '12+ months' },
];

export const reasonForSaleOptions = [
  { value: 'portfolio-rebalancing', label: 'Portfolio Rebalancing' },
  { value: 'upgrade-replacement', label: 'Upgrade / Replacement' },
  { value: 'downsizing', label: 'Downsizing' },
  { value: 'liquidation', label: 'Liquidation' },
  { value: 'estate-inheritance', label: 'Estate / Inheritance' },
  { value: 'other', label: 'Other' },
];

export const mandateOptions = [
  { value: 'exclusive-mandate', label: 'Exclusive Mandate' },
  { value: 'non-exclusive-mandate', label: 'Non-Exclusive Mandate' },
  { value: 'no-mandate', label: 'No Mandate in Place' },
];

export const encumbrancesOptions = [
  { value: 'none', label: 'None' },
  { value: 'yes-details-in-notes', label: 'Yes (details in notes)' },
  { value: 'prefer-not-to-disclose', label: 'Prefer Not to Disclose' },
];

// Used by SellerApplicationForm to display human-readable labels for stored values
export const sellerFormValueMap = Object.fromEntries(
  [
    ...sellerRepresentationOptions,
    ...sellerProfileOptions,
    ...documentationOptions,
    ...proofAvailableOptions,
    ...sellerTimelineOptions,
    ...reasonForSaleOptions,
    ...mandateOptions,
    ...encumbrancesOptions,
  ].map(({ value, label }) => [value, label])
);
